export class Node {
    active = true;
    constructor(public id: number) {}
}
